/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Upfront_AmountInputs */

const en_case_payment_upfront_amount = /** @type {(inputs: Case_Payment_Upfront_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upfront amount`)
};

const pt_br2_case_payment_upfront_amount = /** @type {(inputs: Case_Payment_Upfront_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor à vista`)
};

/**
* | output |
* | --- |
* | "Upfront amount" |
*
* @param {Case_Payment_Upfront_AmountInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_upfront_amount = /** @type {((inputs?: Case_Payment_Upfront_AmountInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Upfront_AmountInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_upfront_amount(inputs)
	return pt_br2_case_payment_upfront_amount(inputs)
});